import { createReducer, on } from '@ngrx/store';
import {
  ClearFilters,
  SetFilterCount,
  SetFilters,
} from '@core/state/tracking/shipments.actions';

export interface ShipmentsState {
  filters: any;
  filterCount: number;
}

export const shipmentStateInitialState: ShipmentsState = {
  filters: null,
  filterCount: 0,
};

export const shipmentsReducer = createReducer(
  shipmentStateInitialState,
  on(SetFilters, (state, { filters }) => ({
    ...state,
    filters: filters,
  })),
  on(SetFilterCount, (state, { count }) => ({
    ...state,
    filterCount: count,
  })),
  on(ClearFilters, (state) => ({ ...state, filters: null }))
);
